import { Navigate, useLocation } from 'react-router-dom';

/** `/home` → `/library` (keep query + hash). */
export function LegacyHomeRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={`/library${search}${hash}`} replace />;
}

/** `/learn` and `/learn/*` → `/hub` and `/hub/*`. */
export function LegacyLearnRedirect() {
  const { pathname, search, hash } = useLocation();
  const next = pathname.replace(/^\/learn(?=\/|$)/, '/hub');
  return <Navigate to={`${next}${search}${hash}`} replace />;
}
